import { VStack } from '@chakra-ui/react';
import { memo, useMemo } from 'react';
import { Property } from '../../domain/property-types';
import { ElementCategory } from '../company/ElementCategories';
import ElementAttributeItem from './ElementAttributeItem';
import { PanelContent } from './Panel';
import { DbIdsPerModel } from './ForgeViewer';

export default memo(function ElementAttributesContent({
  allowedCategories,
  resolvedProperties,
  projectId,
  selectedDbIds,
}: {
  allowedCategories: ElementCategory[];
  resolvedProperties: Property[];
  projectId: string;
  selectedDbIds: DbIdsPerModel;
}): React.ReactElement {
  const attributeItems = useMemo(
    () =>
      allowedCategories.map((opt) => (
        <ElementAttributeItem
          key={opt.name}
          category={opt.name}
          categoryData={opt}
          selectedDbIds={selectedDbIds}
          projectId={projectId}
          values={resolvedProperties
            .filter(
              (property) =>
                property.attribute.category === 'Sparkel Attributes' &&
                property.attribute.name === opt.name
            )
            .map((prop) => prop.value)}
        />
      )),
    [allowedCategories, projectId, resolvedProperties, selectedDbIds]
  );

  return (
    <PanelContent padding={0}>
      <VStack gap={1}>{attributeItems}</VStack>
    </PanelContent>
  );
});
